import {
  styled,
  TextField as BaseTextField,
  InputLabel as BaseInputLabel,
  WithTheme,
} from '@material-ui/core'

interface InputLabelProps extends WithTheme {
  labelSize?: number
}

interface TextFieldProps extends WithTheme {
  wrapHelperText?: boolean
}

const INPUT_HEIGHT = 32
const HELPER_TEXT_HEIGHT = 0
const HELPER_TEXT_BOTTOM = 0
const HELPER_TEXT_LEFT = -10
export const LOADER_SIZE = 20

export const TextField = styled(BaseTextField)(
  ({ wrapHelperText, theme }: TextFieldProps) => ({
    '& .MuiInputBase-root': {
      height: INPUT_HEIGHT,
      '& input': {
        boxShadow: 'none',
      },
    },
    '& fieldset': {
      top: 0,
    },
    '& p[class*=MuiFormHelperText-contained]': {
      lineHeight: '15px',
      ...(wrapHelperText
        ? {
            position: 'relative',
            height: 'max-content',
            width: '100%',
            whiteSpace: 'pre-wrap',
            margin: theme.spacing(0, 0, 0, 0.5),
          }
        : {
            position: 'absolute',
            bottom: HELPER_TEXT_BOTTOM,
            left: HELPER_TEXT_LEFT,
            height: HELPER_TEXT_HEIGHT,
            whiteSpace: 'nowrap',
          }),
    },
  })
)

export const InputLabel = styled(BaseInputLabel)(
  ({ theme, labelSize }: InputLabelProps) => ({
    marginBottom: theme.spacing(),
    whiteSpace: 'nowrap',
    fontSize: labelSize || undefined,
  })
)
